import { createContext } from "react";

export const peopleStorageKey = (userId: string, companyId: number | null) =>
  `clank.filter.people.v1:${companyId ?? "personal"}:${userId}`;

export const DashboardPeopleSelectionContext = createContext({
  selection: "all",
  remember: (_selection: string) => {},
});
